<template>
  <v-container fluid class="av-page">
    <!-- FILTROS -->
    <div class="av-card av-filtro-card">
      <span class="av-section-label">Filtros</span>
      <v-row dense align="end">
        <v-col cols="12" sm="6" md="3" v-if="user.tipo == 'ADMIN'">
          <label class="av-field-label">Empresa</label>
          <v-autocomplete
            outlined
            dense
            hide-details
            v-model="empresaSelecionada"
            :items="empresas"
            item-text="nome"
            item-value="id"
            placeholder="Selecione a empresa"
            no-data-text="Nenhuma empresa encontrada"
            @input="questionarioId = ''; carregaQuestionarios(empresaSelecionada)"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <label class="av-field-label">Questionário</label>
          <v-autocomplete
            outlined
            dense
            hide-details
            v-model="questionarioId"
            :items="questionarios"
            item-text="titulo"
            item-value="id"
            placeholder="Selecione o questionário"
            no-data-text="Nenhum questionário encontrado"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label class="av-field-label">Data Início</label>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedInicio"
                append-icon="event"
                @blur="date = parseDate(dateFormattedInicio)"
                v-on="on"
                outlined
                dense
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataInicio" no-title @input="menu1 = false" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label class="av-field-label">Data Fim</label>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedFim"
                append-icon="event"
                @blur="date = parseDate(dateFormattedFim)"
                v-on="on"
                outlined
                dense
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataFim" no-title @input="menu2 = false" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-btn block depressed color="primary" :disabled="!questionarioId" @click="carregaPerguntasRespostas">
            <v-icon left>search</v-icon>Buscar
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="av-card av-panel">
      <div class="av-toolbar">
        <v-text-field
          v-model="tabela.busca"
          append-icon="search"
          label="Procurar"
          outlined
          dense
          hide-details
          single-line
          class="av-busca"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" :disabled="desativaExportacaoAvaliacoesGeral">
          <download-csv :data="listaAvaliacoesGeral" encoding="UTF-8" name="Relatorio de Respostas.csv" :separator-excel="true">
            <span class="av-export-label"><v-icon left small>cloud_download</v-icon>Baixar relatório</span>
          </download-csv>
        </v-btn>
      </div>

      <v-data-table
        :loading="tabela.carregamento"
        :loading-text="'Buscando respostas...'"
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-desc
        class="av-table"
      >
        <template v-slot:no-data>
          <v-alert v-if="user.tipo == 'ADMIN' && (empresaSelecionada == '' || questionarioId == '')" dense text outlined type="info" class="my-4">
            Selecione uma empresa e um questionário para visualizar as respostas
          </v-alert>
          <v-alert v-else-if="user.tipo != 'ADMIN' && questionarioId == ''" dense text outlined type="info" class="my-4">
            Selecione um questionário para visualizar as respostas
          </v-alert>
          <v-alert v-else dense text outlined type="warning" class="my-4">
            Nenhuma resposta encontrada
          </v-alert>
        </template>
        <template slot="no-results">
          <v-alert dense text outlined type="warning" class="my-4">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
        </template>
        <template v-slot:[`item.envioMensagem`]="{ item }">
          <span v-if="item.envioMensagem">{{ transformaData(item.envioMensagem, 'DD/MM/YYYY') }} às {{ transformaData(item.envioMensagem, 'HH:mm:ss') }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="verDetalhes(item)">
                <v-icon small color="primary">mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver avaliações</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="deleteItem(item)">
                <v-icon small color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialogoDetalhes" persistent max-width="900px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">Avaliações</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <div class="av-toolbar">
            <v-text-field
              v-model="tabela.busca"
              append-icon="search"
              label="Procurar"
              outlined
              dense
              hide-details
              single-line
              class="av-busca"
            ></v-text-field>
          </div>
          <v-data-table
            :search="tabelaDetalhes.busca"
            :headers="tabelaDetalhes.cabecalho"
            :items="tabelaDetalhes.conteudo"
            class="av-table"
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.created`]="{ item }">
              <span>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</span>
            </template>
            <template v-slot:no-data>
              <v-alert dense text outlined type="warning" class="my-4">Nenhuma avaliação encontrada</v-alert>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoDetalhes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#2f7d74" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: { Snackbar, Loading },
    data: vm => ({
      fullPage: true,
      isLoading: false,
      tabela: {
        busca: '',
        cabecalho: [],
        carregamento: false,
        itensPorPagina: -1,
        conteudo: [],
      },
      tabelaDetalhes: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'clienteNome', },
          { text: 'Telefone', align: 'start', value: 'clienteTelefone', },
          { text: 'Profissional', align: 'start', value: 'profissional.nome', },
          { text: 'Setor', align: 'start', value: 'profissional.setor', },
          { text: 'Nota', align: 'start', value: 'nota', },
          { text: 'Enviado em', align: 'start', value: 'envioMensagem', },
        ],
        conteudo: [],
      },
      dialogoDetalhes: false,
      empresas: [],
      empresaSelecionada: '',
      questionarios: [],
      perguntas: [],
      questionarioId: '',
      desativaExportacaoAvaliacoesGeral: true,
      listaAvaliacoesGeral: [],
      date: new Date().toISOString().substring(0, 10),
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },

      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaQuestionarios()
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaQuestionarios(empresaId) {
        const id = empresaId || this.companyobj.id
        this.questionarios = []
        await axios.get(baseApiUrl + 'Questionarios?filter={"where":{"empresaId":"' + id + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.questionarios = response.data

            if (this.companyobj.nome && this.companyobj.nome.toLowerCase().includes('roseanne')) {
              this.questionarios.push({
                'titulo': 'Todos',
                'id': 'Todos'
              })
            }
          }
        })
      },

      async carregaPerguntasRespostas() {
        this.tabela.carregamento = true
        this.desativaExportacaoAvaliacoesGeral = true
        let url = ''
        let dados = {
          "questionarioId": null,
          "dataInicio": this.dataInicio,
          "dataFim": this.dataFim
        }

        if (this.questionarioId == 'Todos') {
          let questionarioId = []

          // obtendo IDs dos questionários para enviar ao endpoint
          for (let i = 0; i < this.questionarios.length; i++) {
            if (this.questionarios[i].titulo != 'Todos') {
              questionarioId.push(this.questionarios[i].id)
            }
          }

          url = baseApiUrl + 'Respostas/todos?access_token=' + sessionStorage.getItem('accToken')
          dados.questionarioId = questionarioId
        } else {
          url = baseApiUrl + 'Respostas/porQuestionario?access_token=' + sessionStorage.getItem('accToken')
          dados.questionarioId = this.questionarioId
        }

        await axios.post(url, dados)
        .then(response => {
          if (response.data) {
            this.tabela.cabecalho = response.data.perguntas
            this.tabela.conteudo = response.data.respostas
            this.montaListaExportacao()
          }
        })
        
        this.tabela.carregamento = false
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      async deleteItem(item) {
        let vm = this;
        let r = confirm('Realmente deseja EXCLUIR as respostas?')
        
        if (r == true) {
          await axios.post(baseApiUrl + 'Respostas/excluir?access_token=' + sessionStorage.getItem('accToken'), {respostasIds: item.respostasIds})
          .then(() => {
            this.carregaPerguntasRespostas()
            vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
          })
        }
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      montaListaExportacao() {
        const finalData = this.tabela.conteudo.map(data => {
          const row = {};

          this.tabela.cabecalho.forEach(header => {
            row[header.text] = data[header.value];
          });

          return row
        });
        
        this.listaAvaliacoesGeral = finalData
        this.desativaExportacaoAvaliacoesGeral = false
      },

      async pegaAvaliacoes(codPesquisa) {
        let resposta

        await axios.get(baseApiUrl + 'ServiceNotas?filter={"where":{"and":[{"codPesquisa":"' + codPesquisa + '"},{"created":{"gte":"' + this.dataInicio + 'T00:00:00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T23:59:59.999Z"}}]}, "include": "profissional"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            resposta = response.data
          }
        })

        return resposta
      },

      async verDetalhes(item) {
        let dados = await this.pegaAvaliacoes(item.codPesquisa)

        if (dados) {
          this.tabelaDetalhes.conteudo = dados
          this.dialogoDetalhes = true
        }
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    },
  }
</script>

<!-- Estilos globais legados (mantidos para telas ainda não migradas) -->
<style>
  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-filtro-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin-bottom: 8px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .av-busca { max-width: 280px; }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-busca {
      max-width: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  /* Botão de exportação: mantém o conteúdo do download-csv alinhado */
  .av-export-label {
    display: inline-flex;
    align-items: center;
  }

  ::v-deep .av-export-label,
  ::v-deep .av-toolbar .v-btn a {
    color: inherit;
    text-decoration: none;
  }

  /* Respiro confortável entre os filtros */
  ::v-deep .av-filtro-card .row > [class*="col"] {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  /* Cabeçalho legível, sobrepondo o CSS global herdado das telas legadas */
  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>
